import { createStyles } from '@mantine/emotion';
import { ASSISTANT_Z_INDEX } from './constants';

export const useAssistantWidgetStyles = createStyles((theme, _, u) => ({
  container: {
    position: 'fixed',
    bottom: 24,
    right: 24,
    width: 400,
    height: 600,
    zIndex: ASSISTANT_Z_INDEX,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.white,
    borderRadius: theme.radius.md,
    boxShadow: theme.shadows.xl,
    border: theme.other.elements.appBorder,
    overflow: 'hidden',
    [u.dark]: { backgroundColor: theme.colors.dark[7] },
  },
  containerWide: {
    width: 700,
  },
  body: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
  },
  leftPanel: {
    width: 260,
    minWidth: 260,
    borderRight: theme.other.elements.appBorder,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  rightPanel: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `6px ${theme.spacing.sm}`,
    borderBottom: theme.other.elements.appBorder,
    flex: '0 0 auto',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontWeight: 600,
    fontSize: theme.fontSizes.sm,
    color: theme.colors.teal[6],
  },
  memberTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontWeight: 600,
    fontSize: theme.fontSizes.sm,
    color: theme.colors.blue[6],
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  chatArea: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  placeholder: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing.md,
  },
}));
